<div class="ideals-select">
  <ideals-input-control-wrapper #wrapper=wrapper
                                [canShowError]="canShowError"
                                [errorList]="errorList"
                                [errorsToShow]="errorsToShow"
                                [id]="id"
                                [isRequired]="isRequired"
                                [labelCustomClass]="labelCustomClass"
                                [labelPosition]="labelPosition"
                                [label]="label"
                                [labelSuffixTemplate]="labelSuffixTemplate"
                                [prefixClass]="prefixClass"
                                [suffixClass]="suffixClass">
    <ng-select #select
               class="ideals-select__control"
               [appendTo]="config.appendTo"
               [popover]="config.popover"
               [bindLabel]="config.bindLabel"
               [bindValue]="config.bindValue"
               [class.custom-search]="customSearch"
               [class.ng-select__arrow--fixed]="arrowFixed"
               [clearOnBackspace]="config.clearOnBackspace"
               [clearable]="config.clearable"
               [closeOnSelect]="config.closeOnSelect && !config.multiple"
               [disabled]="disabled"
               [dropdownPosition]="dropdownPosition"
               [groupBy]="config.groupBy"
               [id]="wrapper.id"
               [items]="items"
               [multiple]="config.multiple"
               [ngModel]="value"
               [notFoundText]="config.notFoundText"
               [placeholder]="placeholder | translate"
               [searchable]="searchable"
               (blur)="doBlur($event)"
               (change)="doBlur($event)"
               (focus)="doFocus($event)"
               (ngModelChange)="onSelectChange($event)"
               (open)="doOpen()"
               (search)="doSearch($event)"
               data-ideals="open">

      <ng-template let-item="item"
                   ng-label-tmp>
        <span class="ideals-select__label"
              *ngIf="!translateValues else translated"
              idealsOverflow
              [ideals-tooltip]="item[config.bindLabel]">
          {{item[config.bindLabel]}}
        </span>
        <ng-template #translated>
          <span class="ideals-select__label"
                *ngIf="item[config.bindLabel] | translate; let label"
                idealsOverflow
                [ideals-tooltip]="label">
            {{label}}
          </span>
        </ng-template>
      </ng-template>

      <ng-template *ngIf="config.multiple"
                   let-clear="clear"
                   let-items="items"
                   ng-multi-label-tmp>
        <div class="ideals-select__label--multi">
          <span idealsOverflow
                [ideals-tooltip]="placeholder">
            {{placeholder}}
          </span>
          <div class="ideals-select__counter"
               *ngIf="items.length">
            <span class="selected-count">
              {{items.length}}
            </span>
            <button class="clear icons-cross"
                    (click)="clearSelection(clear, items)">
            </button>
          </div>
        </div>
      </ng-template>

      <ng-template *ngIf="customSearch"
                   ng-header-tmp>
        <div class="search"
             data-ideals="ideals-input-search">
          <label class="search-label search-icon icons-search"
                 data-ideals="ideals-search-label">
          </label>
          <input #headerSearch
                 class="search-input"
                 type="text"
                 autocomplete="off"
                 [placeholder]="searchPlaceholder"
                 (input)="select.filter($event?.target?.value)"
                 data-ideals="search-input"/>
        </div>
      </ng-template>
      <ng-template *ngIf="customSearch"
                   ng-footer-tmp>
        <div class="search"
             data-ideals="ideals-input-search">
          <label class="search-label search-icon icons-search"
                 data-ideals="ideals-search-label">
          </label>
          <input #footerSearch
                 class="search-input"
                 type="text"
                 autocomplete="off"
                 [placeholder]="searchPlaceholder"
                 (input)="select.filter($event?.target?.value)"
                 data-ideals="search-input"/>
        </div>
      </ng-template>

      <ng-template ng-notfound-tmp></ng-template>

      <ng-template let-item="item"
                   ng-optgroup-tmp>
        {{item[config.groupByTitle]}}
      </ng-template>

      <ng-template let-index="index"
                   let-item="item"
                   let-item$="item$"
                   ng-option-tmp>
        <div class="ideals-select__option"
             [class.multi]="withCheckboxes">
          <ideals-checkbox *ngIf="withCheckboxes"
                           [id]="'item-'+index"
                           [readonly]="true"
                           [value]="item$.selected">
          </ideals-checkbox>

          <ng-container *ngIf="optionPrefixTemplateRef"
                        [ngTemplateOutlet]="optionPrefixTemplateRef"
                        [ngTemplateOutletContext]="{$implicit:item.id}">
          </ng-container>

          <span *ngIf="!translateValues else translated"
                idealsOverflow
                [ideals-tooltip]="item[config.bindLabel]">
          {{item[config.bindLabel]}}
        </span>
          <ng-template #translated>
          <span *ngIf="item[config.bindLabel] | translate; let label"
                idealsOverflow
                [ideals-tooltip]="label">
            {{label}}
          </span>
          </ng-template>
        </div>
      </ng-template>

    </ng-select>

  </ideals-input-control-wrapper>
</div>
